'use client';

import { c as _c } from "react/compiler-runtime";
import type { ImportQueueController } from '@lib/import-queue-ui/types/import-queue-controller';
import { useListingImport } from '../context/listing-import-context';
import { isListingImportActiveWork } from '../utils/is-listing-import-active-work';
import { mapListingImportToQueueStatus } from '../utils/map-listing-import-to-queue-status';
export function useListingImportController() {
  const $ = _c(7);
  const {
    queue
  } = useListingImport();
  let t0;
  if ($[0] !== queue) {
    t0 = queue.map(_temp);
    $[0] = queue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== queue) {
    t1 = isListingImportActiveWork(queue);
    $[2] = queue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      domainKey: "listings",
      title: "Listing imports",
      subtitle: "CSV unit inventory",
      items: t0,
      hasActiveWork: t1,
      retryItem: _temp2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp2() {}
function _temp(item) {
  return {
    clientId: item.clientId,
    fileName: item.fileName,
    relativePath: item.fileName,
    status: mapListingImportToQueueStatus(item.status),
    errorMessage: item.errorMessage
  };
}